import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { UserLevelBarComponent } from '@core/components/user-level-bar/user-level-bar.component';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';
import { UserCommonInfoComponent } from '../user-common-info/user-common-info.component';
import { CardComponent } from '../../../core/components/card/card.component';
// import { CountUpModule } from 'ngx-countup';
import { UserTradeUrlComponent } from '../user-trade-url/user-trade-url.component';
import { JoinDiscordWidgetComponent } from '../join-discord-widget/join-discord-widget.component';

@Component({
  selector: 'app-my-profile',
  imports: [
    UserLevelBarComponent,
    UserCommonInfoComponent,
    CardComponent,
    // CountUpModule,
    UserTradeUrlComponent,
    JoinDiscordWidgetComponent,
  ],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MyProfileComponent {
  // countUpOptions = {
  //   decimalPlaces: 2,
  //   duration: 1,
  //   prefix: '$',
  // };
  // stats = computed(() => {
  //   return [
  //     {
  //       icon: 'assets/icons/ui/input.svg',
  //       label: 'Deposited',
  //       value: 1593.23,
  //       color: 'gray',
  //     },
  //     {
  //       icon: 'assets/icons/ui/output.svg',
  //       label: 'Withdrawn',
  //       value: 1593.23,
  //       color: 'gray',
  //     },
  //     {
  //       icon: 'assets/icons/ui/trade.svg',
  //       label: 'Wagered',
  //       value: 1593.23,
  //       color: 'gray',
  //     },
  //     {
  //       icon: 'assets/icons/core/price.svg',
  //       label: 'Profit',
  //       value: 1593.23,
  //       color: 'green',
  //       coloredValue: true,
  //     },
  //   ];
  // });

  constructor(
    public sessionService: SessionService,
    private socketService: SocketService
  ) {}

  async toggleProfilePrivacy() {
    await this.socketService.emit('set_profile_privacy', {
      value: this.sessionService.stats().profile_privacy === 0 ? 1 : 0,
    });
    this.sessionService.stats.update((prev) => {
      return {
        ...prev,
        profile_privacy: prev.profile_privacy === 0 ? 1 : 0,
      };
    });
  }
}
